import React from "react";
import Card from "@mui/material/Card";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Loading, Error } from "react-admin";
import useSWR from "swr";
import { isArray } from "../../helpers/methods";
import CardIcon from "./CardIcon";

const errorOrderFilter = { status_in: ["error_payment_mismatch"] };
const url = `/#/orders?filter=${encodeURIComponent(
  JSON.stringify(errorOrderFilter)
)}`;

// Styled components
const Main = styled("div")({
  flex: "1",
  marginLeft: "1em",
  marginTop: 20,
});

const StyledCard = styled(Card)({
  overflow: "inherit",
  textAlign: "right",
  padding: 16,
  minHeight: 52,
});

const Title = styled(Typography)({
  color: "red",
});

const Comp = (props) => {
  const { profile } = props;

  const {
    isValidating,
    error,
    data: orders,
  } = useSWR(
    `${process.env.REACT_APP_CMS_HOST}/orders?status_in=error_payment_mismatch&page=${profile.page._id}&_sort=createdAt:DESC&_limit=200`
  );

  if (isValidating) {
    return <Loading />;
  }
  if (error) {
    return <Error />;
  }

  const showOrders = isArray(orders) ? orders : [];
  if (showOrders.length <= 0) {
    return null;
  }

  return (
    <Main>
      <CardIcon Icon={ShoppingCartIcon} bgColor="red" />
      <StyledCard>
        <Title color="textSecondary">{`Orders require attention`}</Title>
        <Typography variant="h5" component="a" target="_blank" href={url}>
          {`Error payment mismatch ${showOrders.length}`}
        </Typography>
        {/* {Object.keys(ordersByStatus).map((k) => (
          <span key={k}>
            <Typography className={classes.title} color="textSecondary">
              {k}
            </Typography>
            <Typography variant="h5" component="h2">
              {ordersByStatus[k].length}
            </Typography>
          </span>
        ))} */}
      </StyledCard>
    </Main>
  );
};

export default Comp;
